import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { Link, navigate } from 'raviger';
import { Button, Card, ListGroup, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlusSquare, faArrowAltCircleLeft,
} from '@fortawesome/free-solid-svg-icons';
import { faArrowDownToSquare } from '@fortawesome/pro-regular-svg-icons';
import ActionsDropdown from '../components/ActionsDropdown';
import LoadingLink from '../components/LoadingLink';
import History from '../components/History';
import Header from '../components/Header';
import { SystemErrorContext } from '../components/SystemError';

function BuildingDetails({ id, incident, organization }) {

  const { setShowSystemError } = useContext(SystemErrorContext);

  const [data, setData] = useState({name:'', description: '', shelter: null, shelter_name:'', rooms:[], action_history:[]});
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const removeBuildingSubmit = () => {
    axios.delete('/shelter/api/building/' + id + '/')
    .then(response => {
      navigate('/' + organization + '/' + incident + '/shelter/' + data.shelter)
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchBuildingData = async () => {
      // Fetch Building Details data.
      await axios.get('/shelter/api/building/' + id + '/?incident=' + incident, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData(response.data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      })
      .finally(() => setIsLoading(false));
    };
    fetchBuildingData();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id, incident]);

  return (
    <>
    <Header>
    <span
      style={{ cursor: "pointer" }}
      onClick={() => {
        if (data?.shelter) {
          navigate(`/${organization}/${incident}/shelter/${data.shelter}`);
        }
      }}
      className="me-2"
    >
      <FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse />
    </span>
      {data.shelter_name} -&nbsp;
      Building Details
    </Header>
    <Card className="border rounded d-flex" style={{width:"100%"}}>
      <Card.Body>
        <Card.Title>
          <h4>Information</h4>
        </Card.Title>
        <p className="phr" />
        <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
          <ListGroup.Item>
            <b>Name:</b> {data.name}
          </ListGroup.Item>
          {data.description ? <ListGroup.Item>
            <b>Description: </b>{data.description}
          </ListGroup.Item> : ""}
        </ListGroup>
      </Card.Body>
    </Card>
    <Card className="mt-3 border rounded d-flex">
      <Card.Body style={{marginBottom:"-20px"}}>
        <Card.Title>
          <h4>Rooms ({data.rooms.length})
            {isLoading ? (
              <Spinner
                className="align-self-center me-3 float-end"
                {...{
                  as: 'span',
                  animation: 'border',
                  size: undefined,
                  role: 'status',
                  'aria-hidden': 'true',
                  variant: 'light',
                  style: {
                    height: '1.5rem',
                    width: '1.5rem',
                    marginBottom: '0.75rem'
                  }
                }}
              />
            ) : (
              <ActionsDropdown variant="secondary" title="Actions" className="float-end" style={{marginTop:"-4px"}}>
                <LoadingLink href={"/" + organization + "/" + incident + "/shelter/" + data.shelter + "/assign?building_id=" + id} isLoading={isLoading} className="d-block" label="Assign Animals to Building Rooms">
                  <FontAwesomeIcon icon={faArrowDownToSquare} className="fas" style={{cursor:'pointer'}} inverse />
                </LoadingLink>
                <LoadingLink href={`/${organization}/${incident}/shelter/building/${id}/room/new`} isLoading={isLoading} className="d-block" label="Add a Room">
                  <FontAwesomeIcon icon={faPlusSquare} className="fas" style={{cursor:'pointer'}} inverse />
                </LoadingLink>
              </ActionsDropdown>
            )}
          </h4>
        </Card.Title>
        <p className="phr" />
        <span className="d-flex flex-wrap align-items-end">
          {data.rooms.map(room => (
            <span key={room.id} className="me-3 mb-3">
              <Link href={"/" + organization + "/" + incident + "/shelter/room/" + room.id} className="building-link" style={{textDecoration:"none", color:"white"}}>
                <Card className="border rounded shelter-hover-div" style={{width:"110px", height:"110px"}}>
                  <div style={{marginRight:"-2px"}}>
                    <div className="card-header border d-flex align-items-center ps-1" title={room.name} style={{height:"37px", marginLeft:"-1px", marginTop:"-1px", width:"100%", backgroundColor:"#615e5e", fontSize:"16px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
                      {room.name}
                    </div>
                  </div>
                  <Card.Text className="mb-0 ps-1">
                    {room.animal_count||0} Animal{room.animal_count === 1 ? "" : "s"}
                  </Card.Text>
                </Card>
              </Link>
            </span>
          ))}
          {data.rooms.length < 1 ? <p>No rooms have been created yet.</p> : ""}
        </span>
      </Card.Body>
    </Card>
    <History action_history={data.action_history} />
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Building Removal</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to remove this building and all of the associated rooms?</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => removeBuildingSubmit()}>
          Yes
        </Button>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default BuildingDetails;
